module.exports = __webpack_public_path__ + "static/media/top-picks.2841187d.svg";